import { useEffect, useState } from 'react';
import { Trans, t } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { getStatus } from 'utility/requests';

export default function StatusCheck(props) {
    const { i18n } = useLingui();
    const [status, setStatus] = useState('loading'); // loading | ok | maintenance
    const [statusMessages, setStatusMessages] = useState({
        message_en: '',
        message_fr: '',
    });

    useEffect(() => {
        getStatus()
            .then((data) => {
                setStatus(data?.status === 'maintenance' ? 'maintenance' : 'ok');
                setStatusMessages({
                    message_en: data?.message_en || '',
                    message_fr: data?.message_fr || '',
                });
            })
            .catch(() => {
                setStatus('ok');
            });
    }, []);

    if (status === 'loading') {
        return null;
    }

    if (status === 'maintenance') {
        let localizedMaintenanceMessage =
            i18n.locale === 'fr' ? statusMessages.message_fr : statusMessages.message_en;

        // Fallback message if none comes back from the server
        if (!localizedMaintenanceMessage) {
            localizedMaintenanceMessage = t`The site is currently under maintenance. Please come back later.`;
        }

        return (
            <main
                style={{
                    minHeight: '100vh',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '2rem',
                    textAlign: 'center',
                }}
            >
                <div>
                    <img
                        alt={t`FrontDoor+ Logo`}
                        src={`${process.env.REACT_APP_STOREFRONT_S3_LOCATION}/web/frontdoor-plus-logo-wide-black.png`}
                        style={{ height: 92, paddingBottom: 28 }}
                    />
                    <h1>
                        <Trans>We'll Be Back Shortly</Trans>
                    </h1>
                    <p>{localizedMaintenanceMessage}</p>
                </div>
            </main>
        );
    }

    return props.children;
}
